<!-- 条款和条件 -->
<template>
  <div class="terms-container">
    <!-- <h1>{{ terms.title }}</h1> -->
    <div class="content" v-html="terms.content"></div>
  </div>
</template>
<script>
import { getTerm } from "../api/userApi";
export default {
  data() {
    return {
      terms: {
        id: null,
        title: "",
        content: "",
      },
    };
  },
  async created() {
    await this.fetchTerms();
  },
  methods: {
    async fetchTerms() {
      const res = await getTerm();
      console.log(res.data, "res");
      if (res.code === 1) {
        this.terms = {
          id: res.data.id,
          title: res.data.title,
          content: res.data.content,
        };
      }
    },
  },
};
</script>

<style>
.content {
  width: 100%;
  max-width: 87.5rem;
  margin: 0 auto;
}
</style>
